export const bidStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  CANCELLED_BY_BIDDER: 'CANCELLED_BY_BIDDER',
  ACCEPTED: 'ACCEPTED',
});

export const DispachedLoadStatus = Object.freeze({
  AVAILABLE: 'AVAILABLE',
  IN_PROGRESS: 'IN_PROGRESS',
  DELIVERED: 'DELIVERED',
});

export const loadStatus = Object.freeze({
  CANCELED: 'CANCELED',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  PAID: 'PAID',
  FINALIZED: 'FINALIZED',
  SETTLEMENT: 'SETTLEMENT',
});

export const txStatus = Object.freeze({
  OPEN: 'OPEN',

  // standard/manual settlement strategy
  INVOICED: 'INVOICED',
  PAYMENT_REMITTED: 'PAYMENT_REMITTED',
  PAYMENT_RECEIVED: 'PAYMENT_RECEIVED',

  // approve/export to file settlement strategy
  APPROVED: 'APPROVED',
  EXPORTED: 'EXPORTED',

});

export const txSettlementStrategy = Object.freeze({
  NONE: 'NONE',
  MANUAL_SETTLEMENT: 'MANUAL_SETTLEMENT',
  APPROVE_EXPORT_LOADS: 'APPROVE_EXPORT_LOADS',
  QB_EXPORT: 'QB_EXPORT',
});

// these magic indices map to the loads page's corresponding tabs
export const loadsTab = Object.freeze({
  RECURRING: 0,
  REPEAT: 1,
  DISPATCH_OFFERS: 2,
  DIRECT_DISPATCH: 3,
  PLANNER: 4,
  SCHEDULED: 5,
  IN_TRANSIT: 6,
  DELIVERED: 7,
  HISTORY: 8,
});

export const timelineEvent = Object.freeze({
  DOCUMENT_PROCESSING: 'DocumentProcessingEvent',
  USER_CHECKIN: 'UserCheckinEvent',
  USER_MESSAGE: 'UserMessageEvent',
  DRIVER_ASSIGNMENT: 'AssignedDriverEvent',
  DRIVER_ACCEPT_ASSIGNMENT: 'DriverAcceptedLoadEvent',
  CHANGE_LOG: 'ChangeLogEvent',
  LOADING_CHUTE_INSTRUCTIONS: 'LoadingChuteInstructionsEvent',
  TIMESTAMP_CHANGE_LOG_GROUP: '__CHANGE_LOG_GROUP',
  UPLOADING_FILE: '__UPLOADING_FILE',
});

export const NotificationTypes = Object.freeze({
  SUCCESS: 0,
  WARNING: 1,
  ERROR: 2,
});

export const UserPerm = Object.freeze({
  PERM_ADMIN: 'PERM_ADMIN',

  // producer company-specific permissions
  PERM_OFFICE: 'PERM_OFFICE',
  PERM_CREATE_LISTING: 'PERM_CREATE_LISTING',
  PERM_RECEIVING: 'PERM_RECEIVING',

  // trucking company-specific permissions
  PERM_LOAD_ASSIGN: 'PERM_LOAD_ASSIGN',
  PERM_FINANCIAL: 'PERM_FINANCIAL',

  // load nonce permissions
  PERM_ASSIGNED_LOAD_HAULER: 'PERM_ASSIGNED_LOAD_HAULER',
  PERM_LINK_VISITOR: 'PERM_LINK_VISITOR',
});

export const UserRole = Object.freeze({
  ROLE_LTN_ADMIN: 'ROLE_LTN_ADMIN',
});

export const LoadCompanyRole = Object.freeze({
  // These values are not for i18n localization. These are acting as an enum.
  Producer: 'Producer',
  Carrier: 'Carrier',
  OriginStockyard: 'OriginStockyard',
  DestinationStockyard: 'DestinationStockyard',
});

export const Originations = Object.freeze({
  DISPATCHED: 'DISPATCHED',
  SCHEDULED: 'SCHEDULED',
  BIDDING: 'BIDDING',
});



// WEBPACK FOOTER //
// ./src/types/index.js